import * as React from 'react';

const At16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#ED2923", d: "M1.127 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1.333h-14z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M1.127 6.333h14v3.333h-14z" }), /* @__PURE__ */ React.createElement("path", { fill: "#ED2923", d: "M1.127 9.666h14V11a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2z" }));
At16.Size = 16;
At16.Title = "At";

export { At16 as default };
